import { createSelector } from 'reselect'

export const selectDetailedDistrictReportProperties = state => state.detailedDistrictReportProperties;

export const selectTopBulletPoints = createSelector(
    [selectDetailedDistrictReportProperties],
    detailedDistrictReportProperties => detailedDistrictReportProperties.topBulletPoints
);

export const selectCongressId = createSelector(
    [selectDetailedDistrictReportProperties],
    detailedDistrictReportProperties => detailedDistrictReportProperties.congressId
);
    